import api from './apiconfig.js';

const API_BASE = api.API_BASE; // Update with your backend URL

// Helper function to get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

const handleResponse = async (response) => {
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload.message || 'Server error');
    error.payload = payload;
    throw error;
  }
  return payload;
};

// Branch Management
export const fetchBranches = async () => {
  const response = await fetch(`${API_BASE}/branches`, {
    headers: getAuthHeaders()
  });
  return handleResponse(response);
};

export const fetchBranchById = async (id) => {
  const response = await fetch(`${API_BASE}/branches/${id}`, {
    headers: getAuthHeaders()
  });
  return handleResponse(response);
};

export const createBranch = async (branch) => {
  const response = await fetch(`${API_BASE}/branches`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(branch)
  });
  return handleResponse(response);
};

export const updateBranch = async (id, updates) => {
  const response = await fetch(`${API_BASE}/branches/${id}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(updates)
  });
  return handleResponse(response);
};

export const deleteBranch = async (id) => {
  const response = await fetch(`${API_BASE}/branches/${id}`, {
    method: 'DELETE',
    headers: getAuthHeaders()
  });
  return handleResponse(response);
};

// Receipt Settings
export const fetchReceiptSettings = async (branchId) => {
  const response = await fetch(`${API_BASE}/branches/receipt-settings`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ branch_id: branchId })
  });
  return handleResponse(response);
};

export const updateReceiptSettings = async (settings) => {
  const response = await fetch(`${API_BASE}/branches/receipt-settings`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(settings)
  });
  return handleResponse(response);
};

export const resetBranchTokenNumber = async (branchId) => {
  const response = await fetch(`${API_BASE}/branches/receipt-settings/reset-token-number`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ branch_id: branchId })
  });
  return handleResponse(response);
};

export const fetchBranchDashboardData = async () => {
  const response = await fetch(`${API_BASE}/branches/dashboard`, {
    headers: getAuthHeaders()
  });
  return handleResponse(response);
};
